import React, { useEffect, useRef } from "react";
import { useCurrentFrame, useVideoConfig } from "remotion";

export const GeometricBackground: React.FC = () => {
  const frame = useCurrentFrame();
  const { width, height } = useVideoConfig();
  const canvasRef = useRef<HTMLCanvasElement>(null);

  // Quick kinetic shapes data
  const particles = [
    {
      x: 0.1,
      y: 0.1,
      size: 8,
      vx: 3,
      vy: 5,
      color: "rgba(255, 209, 102, 0.2)",
    },
    {
      x: 0.9,
      y: 0.3,
      size: 12,
      vx: -4,
      vy: 6,
      color: "rgba(255, 0, 127, 0.15)",
    },
    { x: 0.3, y: 0.8, size: 6, vx: 5, vy: -3, color: "rgba(0, 242, 254, 0.2)" },
    {
      x: 0.8,
      y: 0.7,
      size: 10,
      vx: -6,
      vy: -4,
      color: "rgba(255, 255, 255, 0.12)",
    },
  ];

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    // Dark high-energy pitch background
    ctx.fillStyle = "#030205";
    ctx.fillRect(0, 0, width, height);

    // Fast moving subtle radial center flash
    const radialFlash = ctx.createRadialGradient(
      width / 2,
      height / 2,
      50,
      width / 2,
      height / 2,
      height * 0.4,
    );
    const pulseGlow = Math.sin(frame * 0.15) * 0.05 + 0.12;
    radialFlash.addColorStop(0, `rgba(255, 0, 127, ${pulseGlow})`);
    radialFlash.addColorStop(1, "rgba(0,0,0,0)");
    ctx.fillStyle = radialFlash;
    ctx.fillRect(0, 0, width, height);

    // Draw fast moving kinetic lines
    ctx.strokeStyle = "rgba(255, 255, 255, 0.02)";
    ctx.lineWidth = 4;
    for (let i = 0; i < 6; i++) {
      const lineX = (frame * 12 + i * 200) % width;
      ctx.beginPath();
      ctx.moveTo(lineX, 0);
      ctx.lineTo(lineX - 100, height);
      ctx.stroke();
    }

    // Draw fast particles
    particles.forEach((part) => {
      const currentX = (part.x * width + part.vx * frame * 2 + width) % width;
      const currentY =
        (part.y * height + part.vy * frame * 2 + height) % height;

      ctx.fillStyle = part.color;
      ctx.beginPath();
      // Draw fast diamonds instead of soft circles! Great kinetic feel
      ctx.moveTo(currentX, currentY - part.size);
      ctx.lineTo(currentX + part.size, currentY);
      ctx.lineTo(currentX, currentY + part.size);
      ctx.lineTo(currentX - part.size, currentY);
      ctx.closePath();
      ctx.fill();
    });
  }, [frame, width, height]);

  return (
    <canvas
      ref={canvasRef}
      width={width}
      height={height}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1,
      }}
    />
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
